// NOTE on token storage: the auth flow uses httpOnly cookie (set in /api/auth/* responses)
// AS PRIMARY storage. localStorage is a documented fallback ONLY for environments where the
// cross-origin cookie is dropped (iOS PWA / WebView). Removing it would break session
// persistence in those targets. XSS attacker with JS on this origin would equally call
// /api/auth/me with credentials:include, so localStorage adds little additional risk.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Stable per-device session id for guest mode (allows guests to keep their order
// history on this device without ever creating an account).
function ensureSessionId() {
  let sid = localStorage.getItem("kapei_session_id");
  if (!sid) {
    sid = (crypto?.randomUUID && crypto.randomUUID()) ||
      `kapei-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("kapei_session_id", sid);
  }
  return sid;
}
export const SESSION_ID = ensureSessionId();

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("kapei_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  config.headers["X-Session-Id"] = SESSION_ID;
  return config;
});

export default api;

export function formatApiError(detail) {
  if (detail == null) return "Algo ha fallado. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
